var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FundoLight",style:(_vm.CoresLightning)},[_c('div',{staticClass:"poligonoRaio1"}),_c('div',{staticClass:"poligonoRaio2"})])}
var staticRenderFns = []

export { render, staticRenderFns }